// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputField_textQuestionContainer__E45a6 {
  padding: 10px 20px;
  width: 70%;
  border-color: #dcdcdc;
  border-width: 0.800000011920929px;
  border-style: solid;
  border-radius: 8px;
  /* height: 80px; */
  background: #ffffff;
  margin: 20px 0;
}
.InputField_textQuestionContainer__E45a6 p {
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  color: #aaaaaa;
}
.InputField_textQuestionContainer__E45a6 input:focus {
  font-size: 20px;
  outline: none;
  font-weight: normal;
  font-style: normal;
  color: #000000;
}
.InputField_textQuestionContainer__E45a6 input {
  width: 100%;
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  color: #000000;
  margin-top: 5px;
}
.InputField_labelRadio__k5yW- {
  /* width: 3%; */
  display: flex;
  justify-content: flex-start;
  margin-right: 90px;
  margin-top: 14px;
}
.InputField_labelRadio__k5yW- p {
  margin-left: 5px;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  text-align: left;
  color: #000000;
}
.InputField_radioBtn__GLJs2 input[type="radio"] {
  accent-color: #ec1e27;
  width: 17px;
  height: 17px;
}
.InputField_checkBoxBtn__BHeQc input[type="checkbox"] {
  accent-color: #ec1e27;
  width: 17px;
  height: 17px;
}
.InputField_radioButtonAlign__ozdrN {
  display: flex;
  align-items: center;
}
.InputField_uploadContainer__L8Sdg {
  width: 70%;
  margin: 20px 0;
}
.InputField_uploadContainer__L8Sdg p {
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  color: #aaaaaa;
}
.InputField_uploadImage__nybE\\+ {
  display: block;
  width: 170px;
  height: 90px;
  border-color: #dcdcdc;
  border-width: 0.800000011920929px;
  border-style: solid;
  border-radius: 5px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 12px;
}
.InputField_uploadImage__nybE\\+ p {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  color: #6c6c6c;
  margin-top: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/QuestionAnswer/components/InputFields/InputField.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".textQuestionContainer {\n  padding: 10px 20px;\n  width: 70%;\n  border-color: #dcdcdc;\n  border-width: 0.800000011920929px;\n  border-style: solid;\n  border-radius: 8px;\n  /* height: 80px; */\n  background: #ffffff;\n  margin: 20px 0;\n}\n.textQuestionContainer p {\n  font-size: 18px;\n  font-weight: normal;\n  font-style: normal;\n  color: #aaaaaa;\n}\n.textQuestionContainer input:focus {\n  font-size: 20px;\n  outline: none;\n  font-weight: normal;\n  font-style: normal;\n  color: #000000;\n}\n.textQuestionContainer input {\n  width: 100%;\n  font-size: 20px;\n  font-weight: normal;\n  font-style: normal;\n  color: #000000;\n  margin-top: 5px;\n}\n.labelRadio {\n  /* width: 3%; */\n  display: flex;\n  justify-content: flex-start;\n  margin-right: 90px;\n  margin-top: 14px;\n}\n.labelRadio p {\n  margin-left: 5px;\n  font-size: 18px;\n  font-weight: normal;\n  font-style: normal;\n  text-align: left;\n  color: #000000;\n}\n.radioBtn input[type=\"radio\"] {\n  accent-color: #ec1e27;\n  width: 17px;\n  height: 17px;\n}\n.checkBoxBtn input[type=\"checkbox\"] {\n  accent-color: #ec1e27;\n  width: 17px;\n  height: 17px;\n}\n.radioButtonAlign {\n  display: flex;\n  align-items: center;\n}\n.uploadContainer {\n  width: 70%;\n  margin: 20px 0;\n}\n.uploadContainer p {\n  font-size: 18px;\n  font-weight: normal;\n  font-style: normal;\n  color: #aaaaaa;\n}\n.uploadImage {\n  display: block;\n  width: 170px;\n  height: 90px;\n  border-color: #dcdcdc;\n  border-width: 0.800000011920929px;\n  border-style: solid;\n  border-radius: 5px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin-top: 12px;\n}\n.uploadImage p {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n  color: #6c6c6c;\n  margin-top: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textQuestionContainer": `InputField_textQuestionContainer__E45a6`,
	"labelRadio": `InputField_labelRadio__k5yW-`,
	"radioBtn": `InputField_radioBtn__GLJs2`,
	"checkBoxBtn": `InputField_checkBoxBtn__BHeQc`,
	"radioButtonAlign": `InputField_radioButtonAlign__ozdrN`,
	"uploadContainer": `InputField_uploadContainer__L8Sdg`,
	"uploadImage": `InputField_uploadImage__nybE+`
};
export default ___CSS_LOADER_EXPORT___;
